import Request from '../../utils/request'

export const PunchServer = {
    createPunch() {
        return Request.$get('/operating/api/schedule/create', {})
    },
    getUnusedAwards() {
        return Request.$get('/operating/api/schedule/unused_awards', {})
    },
    getUsedAwards() {
        return Request.$get('/operating/api/schedule/used_awards', {})
    },
    getMedalSharecard() {
            return Request.$get('/operating/api/schedule/get_medal_sharecard', {})
    },
    getContactQrcode() {
            return Request.$get('/operating/api/schedule/get_contact_qrcode', {})
    },
    isNeedShowMedal() {
            return Request.$get('/operating/api/schedule/need_pop_medal', {})
    }
}

export default PunchServer



// WEBPACK FOOTER //
// ./src/services/Modules/punchServer.ts